'use client'

import { CloseX } from '@/features/veluvit/components/overlay/layer-parts'
import SafeImage from '@/features/veluvit/components/ui/media-image'
import { useCatalogMedia } from '@/features/veluvit/hooks/use-app-data'
import { workFor } from '@/features/veluvit/lib/rules'

import type { ChatSpeakerProfile } from '@/features/veluvit/lib/chat-speaker'

/**
 * 프로필 크게 보기(카카오톡 프로필 결) — 대화방 둥근 프사를 누르면 뜬다.
 * 뒤는 대표 이미지(세로 그림)를 크게 깔고, 아래쪽에 얼굴 사진(채팅 프로필 사진, 없으면 대표 이미지 위쪽) · 이름 · 한 줄 소개.
 */
export default function ProfileModal({
  workId,
  profile,
}: {
  workId: string
  profile?: ChatSpeakerProfile
}) {
  const { catalog, src, thumb } = useCatalogMedia()
  const c = catalog.chars[workId]
  const lead = workFor(catalog, workId)?.cast?.[0]
  const name = profile?.name || lead?.name || c?.name || ''
  const line = profile ? profile.role : lead?.role || c?.subtitle || ''
  return (
    <>
      <div className="-mt-2 flex justify-end">
        <CloseX />
      </div>
      <div className="relative mt-1 aspect-[3/4] overflow-hidden rounded-panel bg-surface">
        <SafeImage
          src={profile?.image || src(workId, 'cover')}
          fallbackSrc={profile?.avatar || thumb(workId)}
          alt=""
          fill
          sizes="(max-width: 480px) 100vw, 420px"
          className="object-cover object-[50%_18%]"
          appearance="plain"
        />
        {/* 아래쪽을 어둡게 — 얼굴 사진 · 이름이 그림 위에서 읽히게 */}
        <div
          aria-hidden="true"
          className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 to-transparent"
        />
        <div className="absolute inset-x-0 bottom-0 flex flex-col items-center px-5 pb-6 text-center">
          <div className="relative size-24 overflow-hidden rounded-[34%] bg-surface shadow-[0_0_0_3px_rgb(0_0_0/0.35)]">
            <SafeImage
              src={profile?.avatar || src(workId, 'avatar')}
              fallbackSrc={profile?.image || thumb(workId)}
              alt={`${name} 프로필 사진`}
              fill
              sizes="96px"
              className="object-cover object-[50%_12%]"
              appearance="plain"
            />
          </div>
          <p className="mt-3 text-c18 font-bold text-white">{name}</p>
          {line && (
            <p className="mt-1 max-w-full truncate text-c13 text-white/70">
              {line}
            </p>
          )}
        </div>
      </div>
    </>
  )
}
